const EntityIdType = [
  { value: 0, name: 'Lei', description: 'LEI' },
  { value: 1, name: 'Ein', description: 'EIN' },
  { value: 2, name: 'Brn', description: 'BRN' },
  { value: 3, name: 'Other', description: 'Other' },
];

EntityIdType.getSortedTypes = () => EntityIdType.sort((a, b) => {
  if (a.description > b.description) return 1;
  return (b.description > a.description) ? -1 : 0;
});

export default EntityIdType;
